export default __webpack_public_path__ + "3052e69859a09a3150e9cdceb4e6f91b.jpg";